<top-bar-tabs></top-bar-tabs>
<div class="container">
  <div class="filters">
    <deal-search [control]="filterControls.controls.project_id"></deal-search>
    <mat-form-field>
      <mat-label>Status</mat-label>
      <mat-select [formControl]="filterControls.controls.consent_status_id">
        <mat-option>&mdash;</mat-option>
        @for (status of approvalsService.consentStatuses$ | async; track status) {
          <mat-option
            [value]="status.id">
            {{ status.status }}
          </mat-option>
        }
      </mat-select>
    </mat-form-field>
    <mat-form-field>
      <mat-label>Request Type</mat-label>
      <mat-select
        [formControl]="filterControls.controls.consent_request_type_id">
        <mat-option>&mdash;</mat-option>
        @for (
          consentType of approvalsService.consentRequestTypes$ | async
          ; track
          consentType) {
          <mat-option
            [value]="consentType.id">
            {{ consentType.request_type }}
          </mat-option>
        }
      </mat-select>
    </mat-form-field>
    <mat-form-field>
      <mat-label>Received</mat-label>
      <input
        [formControl]="filterControls.controls.received_date"
        matInput
        [matDatepicker]="picker" />
      <mat-datepicker-toggle
        matIconSuffix
      [for]="picker"></mat-datepicker-toggle>
      <mat-datepicker #picker></mat-datepicker>
    </mat-form-field>
    <mat-form-field>
      <mat-label>Timing</mat-label>
      <input
        matInput
        [formControl]="filterControls.controls.timing_date"
        [matDatepicker]="timingPicker" />
      <mat-datepicker-toggle
        [for]="timingPicker"
      matIconSuffix></mat-datepicker-toggle>
      <mat-datepicker #timingPicker></mat-datepicker>
    </mat-form-field>
  </div>
  <div class="table-header">
    <div class="table-label">
      <h2>Consent Approvals</h2>
    </div>
    <span class="pagination-container">
      @if (approvalsService.approvalsLoading$ | async) {
        <mat-spinner
          class="consents-loading-spinner"
        ></mat-spinner>
      }
      <mat-paginator
        class="mat-paginator-sticky"
        [pageSize]="perPage"
        [hidePageSize]="true"
        [showFirstLastButtons]="true"
        [pageIndex]="currentPage"
        (page)="getPage($event)"
        [length]="total"
        [disabled]="
          !!(approvalsService.approvalsLoading$ | async)
        "></mat-paginator>
    </span>
  </div>
  <div class="table-container">
    <table mat-table [dataSource]="data">
      <ng-container matColumnDef="checklist">
        <th mat-header-cell *matHeaderCellDef></th>
        <td mat-cell *matCellDef="let item">
          <button
            mat-icon-button
            (click)="openChecklistDialog(item.request.id)">
            <consent-checklist-indicator
            [indicatorState]="item.checklist"></consent-checklist-indicator>
          </button>
        </td>
      </ng-container>
      <ng-container matColumnDef="project">
        <th mat-header-cell *matHeaderCellDef>Deal</th>
        <td mat-cell *matCellDef="let item">
          <div>
            <contact-link [subject]="item.project"></contact-link>
          </div>
          @if (item.sponsor) {
            <div>
              <contact-link [subject]="item.sponsor"></contact-link>
            </div>
          }
        </td>
      </ng-container>
      <ng-container matColumnDef="request_type">
        <th mat-header-cell *matHeaderCellDef>Request</th>
        <td mat-cell *matCellDef="let item">
          <div>{{ item.requestType }}</div>
          <div>{{ item.received }}</div>
        </td>
      </ng-container>
      <ng-container matColumnDef="details">
        <th mat-header-cell *matHeaderCellDef>Details</th>
        <td mat-cell *matCellDef="let item">{{ item.details }}</td>
      </ng-container>
      <ng-container matColumnDef="urgency">
        <th mat-header-cell *matHeaderCellDef>Timing/Urgency</th>
        <td mat-cell *matCellDef="let item">
          <span class="timing-wrapper">
            <span class="timing-side">
              <span class="date">
                <mat-icon [class]="item.is_urgent ? 'urgent' : ''">{{
                  item.is_urgent ? "flag" : "outlined_flag"
                }}</mat-icon>
                @if (item.timing?.length) {
                  <span>{{ item.timing }}</span>
                }
              </span>
              <span class="urgency-note">{{ item.urgency_note }}</span>
            </span>
          </span>
        </td>
      </ng-container>
      <ng-container matColumnDef="status">
        <th mat-header-cell *matHeaderCellDef>Status</th>
        <td mat-cell *matCellDef="let item">{{ item.status }}</td>
      </ng-container>
      <ng-container matColumnDef="approvals">
        <th mat-header-cell *matHeaderCellDef></th>
        <td mat-cell *matCellDef="let item">
          <approvals-table
            [approvalItems]="item.approvals"
            [approvalStatuses]="
              (approvalsService.consentApprovalStatuses$ | async) ?? []
            "
            [approvalsLoading]="!!(approvalsService.approvalsLoading$ | async)"
            [permission]="approvalsService.permission$ | async"
            [readOnly]="true"
            (updatedItems)="
              $event
                ? getPage({
                    pageIndex: currentPage,
                    pageSize: perPage,
                    length: total
                  })
                : ''
            "
            [statuses]="
              (approvalsService.consentRequiredStatuses$ | async) ?? []
            "></approvals-table>
        </td>
      </ng-container>
      <tr mat-header-row *matHeaderRowDef="columns"></tr>
      <tr mat-row *matRowDef="let row; columns: columns"></tr>
    </table>
  </div>
</div>
